import styled from 'styled-components';
import { Paper } from '../../atoms/Paper';

export const StyledPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing['8px']};
  flex: 1;
`;

export const PaperWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const PaperHeader = styled.div`
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${(props) => props.theme.spacing['16px']};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyWarm[20]};
`;

export const PaperContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;
